import * as Routes from '../routing/Routes';
import { AuthRoles } from '../auth';

const BROCHURES = 'brochures';
const LOGOS = 'logos';
const DEALER_SUCCESS = 'dealerSuccess';
const LEARNING = 'learning';
const MANUALS = 'manuals';
const PARTS = 'parts';
const PRODUCT_REGISTRATION = 'productRegistration';
const SELLING = 'selling';
const WARRANTY_CLAIMS = 'warrantyClaims';
const ADDITIONAL_RESOURCES = 'additionalResources';

const filterAuthorizedTools = (
  tools = [],
  authUser,
  nestedToolsKey = 'subItems'
) => {
  const toolPermissions = authUser.tools;

  const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');

  return tools.filter(tool => {
    if (isAGIUser) return true;
    const { hasToolOverride } = tool;

    const toolPermissionKeyUndefined = tool.toolPermissionKey === undefined;
    const toolHasNoPermissions =
      toolPermissionKeyUndefined && tool[nestedToolsKey] === undefined;

    const toolHasAuthorizedDropdownOptions =
      toolPermissionKeyUndefined &&
      tool[nestedToolsKey] !== undefined &&
      tool[nestedToolsKey].length > 0;

    return (
      !hasToolOverride &&
      (toolHasNoPermissions ||
        toolHasAuthorizedDropdownOptions ||
        (toolPermissions && toolPermissions[tool.toolPermissionKey]))
    );
  });
};

const routeToolPermissions = [
  {
    route: Routes.brochures,
    toolPermissionKey: BROCHURES
  },
  {
    route: Routes.logos,
    toolPermissionKey: LOGOS
  },
  {
    route: Routes.dealerSuccess,
    toolPermissionKey: DEALER_SUCCESS
  },
  {
    route: Routes.compare,
    toolPermissionKey: LEARNING
  },
  {
    route: Routes.manuals,
    toolPermissionKey: MANUALS
  },
  {
    route: Routes.warrantyreg,
    toolPermissionKey: PRODUCT_REGISTRATION
  },
  {
    route: Routes.additionalResources,
    toolPermissionKey: ADDITIONAL_RESOURCES
  },
  {
    route: Routes.salestool,
    toolPermissionKey: SELLING
  },
  {
    route: Routes.warrantyclaims,
    toolPermissionKey: WARRANTY_CLAIMS
  },
  {
    route: '',
    toolPermissionKey: PARTS
  }
];

export {
  filterAuthorizedTools,
  routeToolPermissions,
  BROCHURES,
  DEALER_SUCCESS,
  LEARNING,
  LOGOS,
  MANUALS,
  PARTS,
  PRODUCT_REGISTRATION,
  ADDITIONAL_RESOURCES,
  SELLING,
  WARRANTY_CLAIMS
};



// WEBPACK FOOTER //
// ./src/utils/ToolPermissions.js